import { BrowserRouter as Router } from 'react-router-dom';
import { Main } from './components/Main';
import './styles/defaults.scss';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { PopUpMessage } from './components/PopUpMessage';
//import { PopUpMessage } from './components/PopUpMessage';

function App() {
  useEffect(() => {
    Aos.init({duration: 500, once: true});
  }, []);
  
  return (
    <Router>
      <PopUpMessage />
      <Main />
    </Router>
  );
}

export default App;
